import en from './locales/en.json';
import de from './locales/de.json';

export const batchCollectionsLocales = {
  en: { money: { batch_transactions: en } },
  de: { money: { batch_transactions: de } },
};

export * from './batch-collections.routes';
